module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('x-number', {
    on: {
      "on-change": _vm.cIt
    },
    model: {
      value: (_vm.vm),
      callback: function($$v) {
        _vm.vm = $$v
      },
      expression: "vm"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b154fb16"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Test2.vue
// module id = 732
// module chunks = 0